import React from "react";
import { Gem, Heart, Crown, Diamond, CakeSlice, Wine, Flower2, Star, Bot } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";

export const PIECES = { ring: Gem, heart: Heart, crown: Crown, gem: Diamond, cake: CakeSlice, wine: Wine, flower: Flower2, star: Star };
export const PIECE_COLORS = ["#C8A96B", "#E11D48", "#2563EB", "#059669", "#9333EA", "#EA580C", "#0891B2", "#DB2777"];

export const avatarSrc = (a) => (!a ? null : a.startsWith("http") ? a : `${BACKEND_URL}${a}`);

export function PlayerAvatar({ p, size = 28, color = "#C8A96B", ring = false }) {
  const Icon = PIECES[p?.piece] || Gem;
  const src = avatarSrc(p?.avatar);
  return (
    <span className="relative inline-flex shrink-0" style={{ width: size, height: size }} title={p?.name}>
      {src ? <img src={src} alt="" className="w-full h-full rounded-full object-cover" style={{ boxShadow: `0 0 0 2px ${color}` }} />
        : <span className="w-full h-full rounded-full flex items-center justify-center text-white" style={{ background: color }}><Icon style={{ width: size * 0.55, height: size * 0.55 }} /></span>}
      {src && <span className="absolute -bottom-1 -right-1 rounded-full flex items-center justify-center text-white" style={{ background: color, width: size * 0.5, height: size * 0.5 }}><Icon style={{ width: size * 0.32, height: size * 0.32 }} /></span>}
      {p?.is_bot && <span className="absolute -top-1 -left-1 rounded-full bg-black/80 text-white flex items-center justify-center" style={{ width: size * 0.45, height: size * 0.45 }}><Bot style={{ width: size * 0.3, height: size * 0.3 }} /></span>}
      {ring && <span className="absolute inset-[-4px] rounded-full border-2 border-white animate-ping" />}
    </span>
  );
}
